import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useUpsertProductVehicleCapacity } from '~/api';
import type { UnitCode } from '~/graphql/graphql';
import { toastGraphQLError } from '~/utils';

type VehicleCapacitySubmission = {
  platformProductLengthId: string;
  transportVehicleId: string;
  value: number;
  unit: UnitCode;
};

export function useSubmitVehicleCapacity() {
  const { t } = useTranslation('cart');
  const { mutate: upsertVehicleCapacity } = useUpsertProductVehicleCapacity();

  return ({
    platformProductLengthId,
    transportVehicleId,
    value,
    unit,
  }: VehicleCapacitySubmission) => {
    if (!transportVehicleId) {
      toast.error(t('cart.no_vehicle_selected_error'));
      return;
    }
    upsertVehicleCapacity(
      {
        platformProductLengthId,
        transportVehicleId,
        capacity: { value, unit },
      },
      { onError: toastGraphQLError }
    );
  };
}
